<template>
  <div id="dispatch_area" class="right_col" role="main">
    <div class="row">
      <div class="col-md-12 col-sm-6 col-xs-12">
        <div class="title_left">
          <h3>派遣區域管理</h3>
          <hr />
        </div>
      </div>
    </div>
    <el-row :gutter="8">
      <el-col :span="2">
        <h4>排班站:</h4>
      </el-col>
      <el-col :span="6">
        <select
          class="inputstyle"
          v-model="select.shift_area_id"
          v-on:change="onShiftAreaChange(select.shift_area_id)"
        >
          <option value="insert">--請選擇--</option>
          <option
            v-for="station in options.shift_area_arr"
            v-bind:value="station.id"
          >
            {{ station.name }}
          </option>
        </select>
      </el-col>
      <el-col :span="2">
        <h4>派遣區派遣區:</h4>
      </el-col>
      <el-col :span="6">
        <select
          class="inputstyle"
          v-model="select.dispatch_area_id"
          v-on:change="onDispatchAreaChange(select.dispatch_area_id)"
        >
          <option value="insert">新增</option>
          <option
            v-for="station in options.dispatch_area_arr"
            v-bind:value="station.id"
          >
            {{ station.name }}
          </option>
        </select>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="16">
        <div id="map" class="mapblocklarge">Google map</div>
      </el-col>
      <el-col :span="8" style="border: 2px solid; padding: 16px">
        <el-row :gutter="8">
          <el-form ref="form" label-width="100px" size="mini">
            <el-form-item label="匯入圖資">
              <a href="javascript:;" class="mybtnstyle btn-dark file">
                匯入圖資
                <input
                  id="upload"
                  v-on:change="onFileChange"
                  type="file"
                  name=""
                />
              </a>
              <span style="color: red">*</span>
              <span v-if="file">{{ file.name }}</span>
            </el-form-item>
            <el-form-item v-if="kmlCreatedDate" label="建立日期">
              <span style="font-size: 1.8rem">
                {{ kmlCreatedDate }}
              </span>
            </el-form-item>
            <el-form-item label="派遣區域名稱">
              <input
                v-model="dispatch_area.name"
                type="text"
                required="required"
                class="inputstyle col-md-5 fontSize16 main_title"
              />
            </el-form-item>
            <el-form-item
              v-if="dispatch_area.dispatch_strategy == '空中排班'"
              label="車數容量"
            >
              <input
                v-model="dispatch_area.area_capacity"
                min="1"
                step="1"
                type="number"
                id="carAmount"
                required="required"
                class="inputstyle col-md-4 fontSize16"
              />
            </el-form-item>
            <el-form-item label="派遣策略">
              <select
                v-model="dispatch_area.dispatch_strategy"
                class="inputstyle col-md-5 fontSize16"
              >
                <option>排班車優先</option>
                <option>距離最近空車</option>
              </select>
            </el-form-item>
            <el-form-item label="派遣排班站1:" v-if="showInLineName2">
              <select
                v-model="dispatch_area.in_line_name1"
                class="inputstyle col-md-5 fontSize16"
              >
                <option selected="" disabled="">排班站名</option>
                <option v-if="!showInLineName2" value="">無</option>
                <option
                  v-for="station in options.shift_area_arr"
                  v-bind:value="station.id"
                >
                  {{ station.name }}
                </option>
              </select>
            </el-form-item>
            <el-form-item
              label="派遣排班站2:"
              v-if="showInLineName2 && dispatch_area.in_line_name1 != null"
            >
              <select
                v-model="dispatch_area.in_line_name2"
                class="inputstyle col-md-5 fontSize16"
              >
                <option selected="" disabled="">排班站名</option>
                <option value="">無</option>
                <option
                  v-for="station in options.shift_area_arr"
                  v-bind:value="station.id"
                >
                  {{ station.name }}
                </option>
              </select>
            </el-form-item>
            <el-form-item label="備註:">
              <el-input
                type="textarea"
                :rows="3"
                placeholder="請輸入內容"
                v-model="dispatch_area.note"
              ></el-input>
            </el-form-item>
            <el-form-item size="large">
              <el-form-item v-if="permisionDispatchArea">
                <el-button
                  size="medium"
                  v-if="select.dispatch_area_id == 'insert'"
                  type="success"
                  @click="onInsertBtnClick"
                >
                  新增
                </el-button>
                <el-button
                  size="medium"
                  v-if="select.dispatch_area_id !== 'insert'"
                  type="primary"
                  @click="onUpdateBtnClick"
                >
                  更新
                </el-button>
                <el-button
                  size="medium"
                  v-if="select.dispatch_area_id !== 'insert'"
                  type="danger"
                  @click="onDeleteBtnClick"
                >
                  刪除
                </el-button>
              </el-form-item>
            </el-form-item>
          </el-form>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import API from '@/assets/js/libs/API'
import dayjs from 'dayjs'
import { ApiKey } from '@/assets/js/libs/GoogleAPI'
import { Notification } from 'element-ui'
import { cookies } from '@/utils/cookies'
import Dispatch_area from '@/assets/js/libs/Dispatch_area'
import GoogleMapsLoader from 'google-maps'
import BehaviorRecorder from '@/assets/js/libs/BehaviorRecorder'
import { getAdminAuthorization } from '@/assets/js/tool/adminAuth'

const dispatchArea = new Dispatch_area()

export default {
  name: 'DispatchArea',
  data() {
    return {
      options: {
        dispatch_area_arr: [],
        shift_area_arr: [],
      },
      dispatch_area: {
        name: '',
        dispatch_strategy: '空中排班',
        area_capacity: 100,
        in_line_name1: null,
        in_line_name2: null,
      },
      originDispatchArea: {},
      shift_area: {},
      shift_area_kml: null,
      select: {
        dispatch_area_id: 'insert',
        shift_area_id: 'insert',
      },
      file: null,
      map: null,
      kmlArray: new Set(),
      kmlUpload: [],
      kmlSchedualArray: [],
      kmlSchedualParser: null,
      kmlParser: null,
    }
  },
  methods: {
    showLoading() {
      this.loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      })
    },
    clearDispatchAreaInfo() {
      this.dispatch_area.name = ''
      this.dispatch_area.note = ''
      this.dispatch_area.dispatch_strategy = '空中排班'
      this.dispatch_area.area_capacity = 100
      this.dispatch_area.in_line_name1 = null
      this.dispatch_area.in_line_name2 = null
      this.file = null
      this.kmlUpload = []
    },
    async onDispatchAreaChange(id) {
      this.clearDispatchAreaInfo()
      if (id === 'insert') {
        this.reloadKml()
      } else {
        try {
          this.showLoading()
          this.kmlParser = new geoXML3.parser({
            map: this.map,
            singleInfoWindow: true,
          })
          const { kmlFile, result } = await API.get(`dispatch-area?id=${id}`)
          localStorage.setItem(`dispatch-${id}`, kmlFile)
          this.dispatch_area = result
          this.originDispatchArea = JSON.parse(
            JSON.stringify(this.dispatch_area),
          )
          const parser = new DOMParser()
          const xmlDoc = parser.parseFromString(kmlFile, 'text/xml')
          const points = xmlDoc
            .querySelector('coordinates')
            .textContent.trim()
            .replace(/\r?\n|\r/g, '')
            .split(',')
          const LatLng = {
            lat: Number(points[1]),
            lng: Number(points[0]),
          }
          if (!this.kmlArray.has(kmlFile)) {
            this.kmlParser.parseKmlString(kmlFile)
            this.kmlArray.add(kmlFile)
          }
          this.map.setCenter({
            lat: LatLng.lat,
            lng: LatLng.lng,
          })
        } catch (e) {
          Notification({
            title: '發生錯誤，請再試一次',
            type: 'error',
          })
          console.error(e)
        } finally {
          this.loader.hide()
        }
      }
    },
    onShiftAreaChange(id) {
      this.showLoading()
      this.kmlSchedualParser = new geoXML3.parser({
        map: this.map,
        singleInfoWindow: true,
      })
      API.get(`/shift-area/?id=${id}`)
        .then((res) => {
          localStorage.setItem(`schedualed-${id}`, res.kmlFile)
          this.shift_area = res.result
          const parser = new DOMParser()
          const xmlDoc = parser.parseFromString(
            localStorage.getItem(`schedualed-${id}`),
            'text/xml',
          )
          const points = xmlDoc
            .querySelector('coordinates')
            .textContent.trim()
            .replace(/\r?\n|\r/g, '')
            .split(',')
          const LatLng = {
            lat: Number(points[1]),
            lng: Number(points[0]),
          }
          this.loader.hide()
          if (this.kmlSchedualArray.includes(res.kmlFile)) {
            /* 移動座標，不需要產生新的圖檔 */
            this.map.setCenter({
              lat: LatLng.lat,
              lng: LatLng.lng,
            })
            return
          }

          this.kmlSchedualParser.parseKmlString(
            localStorage.getItem(`schedualed-${id}`),
          )
          this.kmlSchedualArray.push(localStorage.getItem(`schedualed-${id}`))
        })
        .catch((e) => {
          this.loader.hide()
          Notification({
            title: e + '錯誤碼:002',
            type: 'error',
          })
        })
    },
    onFileChange(e) {
      const fileReader = new FileReader()
      const files = e.target.files
      this.file = files[0]
      if (
        this.file.name.slice(
          ((this.file.name.lastIndexOf('.') - 1) >>> 0) + 2,
        ) !== 'kml'
      ) {
        Notification({
          title: '圖資檔名需要為.kml',
          type: 'error',
        })
        this.file = null
      }
      const reader = new FileReader()
      fileReader.onload = async (e) => {
        if (this.kmlParser === null) {
          this.kmlParser = new geoXML3.parser({
            map: this.map,
            singleInfoWindow: true,
          })
        }
        if (this.kmlUpload.includes(e.target.result)) {
          /* 解析是否有重複 */
          const parser = new DOMParser()
          const xmlDoc = parser.parseFromString(e.target.result, 'text/xml')
          const LatLng = {
            lat: Number(
              xmlDoc
                .getElementsByTagName('coordinates')[0]
                .childNodes[0].nodeValue.trim()
                .split(',')[1],
            ),
            lng: Number(
              xmlDoc
                .getElementsByTagName('coordinates')[0]
                .childNodes[0].nodeValue.trim()
                .split(',')[0],
            ),
          }
          this.map.setCenter({
            lat: LatLng.lat,
            lng: LatLng.lng,
          })
          return
        }
        this.kmlParser.parseKmlString(e.target.result)
        this.kmlUpload.push(e.target.result)
      }
      fileReader.readAsText(this.file, 'utf-8')
    },
    async onInsertBtnClick() {
      if (!this.isValidData() || !this.file) {
        Notification({
          title: '必填欄位未填或是格式錯誤',
          type: 'error',
        })
      } else {
        try {
          const result = await dispatchArea.create(this.formatData())
          if (result.success) {
            await this.getOptions()
            const newId = this.options.dispatch_area_arr.find(
              (obj) => obj.name === this.dispatch_area.name,
            ).id
            this.select.dispatch_area_id = newId
            this.onDispatchAreaChange(newId)
            ;(this.dispatch_area.name = ''),
              (this.dispatch_area.dispatch_strategy = '空中排班'),
              (this.dispatch_area.area_capacity = 100),
              (this.dispatch_area.in_line_name1 = null),
              (this.dispatch_area.in_line_name2 = null)
            this.file = null
            Notification({
              title: '新增成功',
              type: 'success',
            })
          } else {
            Notification({
              title: '新增失敗',
              type: 'error',
            })
          }
        } catch (e) {
          console.error(e)
          Notification({
            title: '新增失敗',
            type: 'error',
          })
        }
      }
    },
    async onDeleteBtnClick() {
      try {
        const result = await dispatchArea.delete(this.select.dispatch_area_id)
        if (result.success) {
          await this.getOptions()
          this.select.dispatch_area_id = 'insert'
          this.onDispatchAreaChange('insert')
          Notification({
            title: '刪除成功',
            type: 'success',
          })
        } else {
          Notification({
            title: '刪除失敗',
            type: 'error',
          })
        }
      } catch (e) {
        console.error(e)
        Notification({
          title: '刪除失敗',
          type: 'error',
        })
      }
    },
    async onUpdateBtnClick() {
      if (!this.isValidData()) {
        Notification({
          title: '必填欄位未填或是格式錯誤',
          type: 'error',
        })
      } else {
        try {
          const task = this.file ? 'updateFile' : 'updateInfo'
          // 取得派遣區域名稱
          const selectedDispatchArea = this.options.dispatch_area_arr.find(
            (area) => area.id === this.select.dispatch_area_id,
          )
          const dispatchAreaName = selectedDispatchArea
            ? selectedDispatchArea.name
            : this.dispatch_area.name
          const result = await dispatchArea.update(
            this.select.dispatch_area_id,
            task,
            this.formatData(),
          )
          if (result.success) {
            this.updateDispatchAreaRecord()
            if (this.file) {
              BehaviorRecorder.record(
                '點擊',
                '派遣區',
                `<${dispatchAreaName}> 重新上傳圖資`,
              )
            }
            await this.getOptions()
            this.onDispatchAreaChange(this.select.dispatch_area_id)
            this.file = null
            Notification({
              title: '更新完成',
              type: 'success',
            })
          } else {
            Notification({
              title: '更新失敗',
              type: 'error',
            })
          }
        } catch (e) {
          console.error(e)
          Notification({
            title: '更新失敗',
            type: 'error',
          })
        }
      }
    },
    isValidData() {
      const data = this.dispatch_area
      return (
        data.name != '' &&
        data.dispatch_strategy != '' &&
        (data.dispatch_strategy == '空中排班'
          ? data.area_capacity != null && data.area_capacity > 0
          : true) &&
        (this.showInLineName2 ? data.in_line_name1 != null : true)
      )
      //當排班車優先時，檢查排班站一是否為空
    },
    formatData() {
      const param = new FormData()
      param.append('name', this.dispatch_area.name)
      if (this.file) param.append('file', this.file)
      if (this.dispatch_area.area_capacity)
        param.append('area_capacity', this.dispatch_area.area_capacity)
      param.append('dispatch_strategy', this.dispatch_area.dispatch_strategy)
      if (this.dispatch_area.in_line_name1)
        param.append('in_line_name1', this.dispatch_area.in_line_name1)
      if (this.dispatch_area.in_line_name2)
        param.append('in_line_name2', this.dispatch_area.in_line_name2)
      param.append(
        'note',
        this.dispatch_area.note == null ? '' : this.dispatch_area.note,
      )
      return param
    },
    isInsertOption(option) {
      return option != 'insert'
    },
    reloadKml() {
      this.initMap()
      const baseUrl = API.getBaseUrl
      const myParser = new geoXML3.parser({
        map: this.map,
      })
      if (this.select.shift_area_id !== 'insert')
        myParser.parse(baseUrl + this.shift_area.path)
      if (this.select.dispatch_area_id !== 'insert')
        myParser.parse(baseUrl + this.dispatch_area.path)
    },
    initMap() {
      const lat = parseFloat(cookies.get('GladAddressGps').coordinates[1])
      const lng = parseFloat(cookies.get('GladAddressGps').coordinates[0])
      this.map = undefined
      this.map = new google.maps.Map(document.getElementById('map'), {
        center: new google.maps.LatLng(lat, lng),
        gestureHandling: 'greedy',
        zoom: 12,
        mapTypeId: 'roadmap',
      })
    },
    async getOptions() {
      try {
        const { result } = await API.get(`/dispatch-area/identificaiton-code`)
        this.options.dispatch_area_arr = result
      } catch (e) {
        console.error(e)
      }
    },
    updateIdentificaitonCode() {
      API.get(`/dispatch-area/identificaiton-code`)
        .then((res) => {
          if (res.err === '無此車隊排班站資料') return
          this.options.dispatch_area_arr = res.result
          let dispatchArea = res.result
          let codeArray = []
          let DispatchAreaArray = []

          for (let i = 0; i < dispatchArea.length; i++) {
            codeArray.push(dispatchArea[i].identification_code)
            DispatchAreaArray.push(`dispatch-${dispatchArea[i].id}`)
          }
          localStorage.setItem(`DispatchAreaArray`, DispatchAreaArray.join(','))
          localStorage.setItem(`DispatchAreaNumber`, codeArray.join(','))
        })
        .catch((e) => {
          Notification({
            title: e + '錯誤代碼: area:001',
            type: 'error',
          })
        })

      API.get(`/shift-area/identificaiton-code`)
        .then((res) => {
          if (res.err === '無此車隊排班站資料') return
          this.options.shift_area_arr = res.result
          let schedualArea = res.result
          let codeArray = []
          let ShiftAreaArray = []

          for (let i = 0; i < schedualArea.length; i++) {
            codeArray.push(schedualArea[i].identification_code)
            ShiftAreaArray.push(`schedualed-${schedualArea[i].id}`)
          }
          localStorage.setItem(`ShiftAreaArray`, ShiftAreaArray.join(','))
          localStorage.setItem(`SchedualAreaNumber`, codeArray.join(','))
        })
        .catch((e) => {
          Notification({
            title: e + '錯誤代碼: area:001',
            type: 'error',
          })
        })
    },
    updateDispatchAreaRecord() {
      this.dispatch_area.call_number = this.dispatch_area.name
      BehaviorRecorder.recordDiffData(
        this.originDispatchArea,
        this.dispatch_area,
        {
          fieldMap: {
            name: '派遣區名稱',
            dispatch_strategy: '派遣策略',
            note: '備註',
          },
          title: '修改派遣區',
          type: '派遣區',
        },
      )
    },
  },
  computed: {
    permisionDispatchArea() {
      return getAdminAuthorization('dispatchArea') === 2
    },
    showInLineName1() {
      if (!this.isInsertOption(this.select.dispatch_area_id)) {
        if (this.dispatch_area.dispatch_strategy == '空中排班')
          this.dispatch_area.area_capacity = 100
        else this.dispatch_area.area_capacity = ''
      }
      return this.dispatch_area.dispatch_strategy != '距離最近空車'
    },
    showInLineName2() {
      return this.dispatch_area.dispatch_strategy == '排班車優先'
    },
    kmlCreatedDate() {
      return this.dispatch_area.createdAt
        ? dayjs(this.dispatch_area.createdAt).format('YYYY-MM-DD HH:mm')
        : null
    },
  },
  mounted() {
    this.updateIdentificaitonCode()
    GoogleMapsLoader.KEY = ApiKey()
    GoogleMapsLoader.LIBRARIES = ['geometry', 'places']
    GoogleMapsLoader.load(() => {
      this.initMap()
    })
  },
}
</script>

<style scoped>
h4 {
  min-width: 140px;
}

input.inputstyle {
  min-width: 240px;
}
</style>



// WEBPACK FOOTER //
// src/pages/area/DispatchArea_modify.vue